import { Advertising } from './advertisingBase'
import { AdParam } from './contanst'

export class AdFixed extends Advertising {
  create () {
    this.init()
    if (!AdParam.isDiagram) {
      this.createEvent()
      const fixed = this.container.querySelector('.Ad-fixed')
      fixed.querySelector('span').addEventListener('click', function (e) {
        e.preventDefault()
        fixed.close = true
        fixed.classList.remove('show')
      })
      window.addEventListener('scroll', function () {
        if (window.scrollY > 150 && !fixed.close) {
          fixed.classList.add('show')
        } else {
          fixed.classList.remove('show')
        }
      })
    }
  }

  setPosition (pos) {
    const container = document.getElementById('fixed-' + this.data.id)
    container.classList.add(pos)
  }

  createEvent () {
    const container = document.getElementById('fixed-' + this.data.id)
    const items = container.querySelectorAll('.item')
    if (items.length > 1) {
      this.createCarousel()
    }
    this.addClick(items)
    this.addPrint(items)
  }
}
